import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Calendar, Modal, Tag, Spin, message, List, Typography } from "antd";
import axios from "axios";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import Get from "../services/Get";

// Extend dayjs with plugins
dayjs.extend(utc);
dayjs.extend(timezone);

const AttendanceCalendar = () => {
  const location = useLocation();
  const { id, type } = location.state || {}; // Single user data
  const [selectedDate, setSelectedDate] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [attendanceLogs, setAttendanceLogs] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchAttendanceLogs = (date) => {
    setLoading(true);
    Get.getSingleAttendance(id, date, type)
      .then((res) => {
        console.log(res);

        if (res.data.length > 0) {
          setAttendanceLogs(res.data);
        }
      })
      .catch((error) => {
        console.error(error);
        message.error(error);
      })
      .finally(() => setLoading(false));
  };

  // Function to handle date selection
  const onSelect = (value) => {
    const formattedDate = value.format("YYYY-MM-DD");
    setSelectedDate(formattedDate);
    fetchAttendanceLogs(formattedDate);
    setIsModalVisible(true);
  };

  return (
    <div style={{ padding: 20 }}>
      <h2>Attendance Calendar</h2>
      <Calendar onSelect={onSelect} />

      <Modal
        title={`Scans for ${selectedDate}`}
        open={isModalVisible}
        onCancel={() => {
          setAttendanceLogs([]);
          setIsModalVisible(false);
        }}
        footer={null}
      >
        {loading ? (
          <Spin />
        ) : attendanceLogs.length > 0 ? (
          <List
            bordered
            dataSource={attendanceLogs}
            renderItem={(item) => (
              <List.Item>
                <Typography.Text mark>
                  {dayjs
                    .utc(item.created_at)
                    .tz("Asia/Kolkata")
                    .format("h:mm:ss A")}
                </Typography.Text>
              </List.Item>
            )}
          />
        ) : (
          <Tag color="red">No Scans</Tag>
        )}
      </Modal>
    </div>
  );
};

export default AttendanceCalendar;
